import { useNavigate } from 'react-router-dom';
import { Button } from '@components/UI';
import type { ScreenerRuleRow } from '@/types/appRouter';

interface RevisionHistoryProps {
    revisions: ScreenerRuleRow[];
    currentScreenerRuleId: number;
    onLoadRevision?: (revisionId: number) => void;
}

const RevisionHistory = ({ revisions, currentScreenerRuleId, onLoadRevision }: RevisionHistoryProps) => {
    const navigate = useNavigate();

    return (
        <div>
            <div className="border border-zinc-700 rounded overflow-hidden">
                <div className="max-h-[300px] overflow-auto">
                    <table className="min-w-full text-xs">
                        <thead className="bg-zinc-900/40 text-zinc-400">
                            <tr>
                                <th className="text-left px-3 py-2">Revision</th>
                                <th className="text-left px-3 py-2">ID</th>
                                <th className="text-left px-3 py-2">Updated</th>
                                <th className="text-left px-3 py-2">Status</th>
                                <th className="text-right px-3 py-2">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {revisions.map((r) => {
                                const isCurrent = r.id === currentScreenerRuleId;
                                const status = r.supersededById == null ? 'latest' : `superseded by #${r.supersededById}`;

                                return (
                                    <tr className={`border-t border-zinc-800 ${isCurrent ? 'bg-zinc-800/40' : ''}`} key={r.id}>
                                        <td className="px-3 py-2">
                                            r{r.revision}
                                            {isCurrent && <span className="ml-1.5 text-blue-400 text-[10px] font-medium">(current)</span>}
                                        </td>
                                        <td className="px-3 py-2">{r.id}</td>
                                        <td className="px-3 py-2">{r.updatedAt}</td>
                                        <td className="px-3 py-2">
                                            <span
                                                className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${
                                                    r.supersededById == null
                                                        ? 'bg-green-900/40 text-green-400'
                                                        : 'bg-zinc-800 text-zinc-500'
                                                }`}
                                            >
                                                {status}
                                            </span>
                                        </td>
                                        <td className="px-3 py-2 text-right">
                                            {!isCurrent && (
                                                <div className="flex justify-end gap-2">
                                                    {onLoadRevision && (
                                                        <Button size="sm" variant="secondary" onClick={() => onLoadRevision(r.id)}>
                                                            Load
                                                        </Button>
                                                    )}
                                                    <Button
                                                        size="sm"
                                                        variant="secondary"
                                                        onClick={() => navigate(`/tools/screener/${r.id}`)}
                                                    >
                                                        View
                                                    </Button>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                            {revisions.length === 0 && (
                                <tr>
                                    <td className="px-3 py-3 text-zinc-400" colSpan={5}>
                                        No revisions found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default RevisionHistory;
